<template>
  <div class="publicBanner">
    <div class="publicCon">
      <h3 :class="bannerInfo.content ? '' : 'single'">{{bannerInfo.title}}</h3>
      <p>{{bannerInfo.content}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["bannerInfo"],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publicBanner/index.vue